/**
 * Interface / Classe base abstrata para estratégias de carregamento de Acompanhamentos.
 *
 * Princípios SOLID:
 * - ISP (Interface Segregation): Define um contrato enxuto e estrito para carregamento.
 * - LSP (Liskov Substitution): Qualquer estratégia concreta pode ser substituída sem efeitos colaterais.
 * - OCP (Open/Closed): Novos perfis de usuários podem estender esta classe sem alterar o orquestrador.
 */
export class IAcompanhamentoStrategy {
  /**
   * Executa a busca e normalização de acompanhamentos para o perfil correspondente.
   *
   * @param {object} params
   * @param {string} params.token - Token JWT da sessão
   * @param {number} [params.page=1]
   * @param {number} [params.limit=50]
   * @param {object} [params.contexto={}] - { busca?: string, empresaId?: string|number }
   * @param {object} [params.identidade={}] - Dados da sessão (usuarioId, nivel, tipo, etc.)
   * @param {AbortSignal} [params.signal] - Sinal de cancelamento HTTP
   * @returns {Promise<Array<object>>} Lista normalizada de itens de acompanhamento
   */
  async carregar(params) {
    throw new Error("O método carregar() deve ser implementado pela estratégia concreta.");
  }
}
